import './i18n/init';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { loadAccount } from './account/actions';
import { startSession } from './ui/session';
import './styles.css';

void startSession();
void loadAccount();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

// Development aid: inspect state from the browser console. Not included in production builds.
if (import.meta.env.DEV) {
  void import('./state/store').then(({ store }) => ((window as unknown as { __stitchcraft: unknown }).__stitchcraft = store));
}
